import React, { useState } from "react";

import SingleUploadField from "./upload-field";
import { MultiFileWrapper } from "./views";

const MultiUploadField = ({ onChange = null, onDelete = null, ...props }) => {
    const [multiFileInput, setMultiFileInput] = useState(props.initialState);
    const [disabled, setDisabled] = useState(false);

    const handleChange = (selectedFile, fileToRemove) => {
        const fileUploads = multiFileInput.uploadedFiles.filter(
            inputFile => inputFile.identifier !== fileToRemove
        );
        fileUploads.push(selectedFile);

        const tempMultiFileInput = {
            ...multiFileInput,
            uploadedFiles: fileUploads
        };
        setMultiFileInput(tempMultiFileInput);

        onChange && onChange(tempMultiFileInput);
    };

    const handleDelete = identifier => {
        const fileUploads = multiFileInput.uploadedFiles.filter(
            inputFile => inputFile.identifier !== identifier
        );

        const tempMultiFileInput = {
            ...multiFileInput,
            uploadedFiles: fileUploads
        };
        setMultiFileInput(tempMultiFileInput);

        if (fileUploads.length > 0) {
            onChange && onChange(tempMultiFileInput);
        } else {
            onChange && onChange(undefined);
            onDelete && onDelete();
        }
    };

    const fileItems = [];

    multiFileInput.uploadedFiles.map(uploadedFile => {
        return fileItems.push(
            <SingleUploadField
                {...props}
                key={uploadedFile.identifier}
                identifier={uploadedFile.identifier}
                value={uploadedFile}
                disabled={disabled}
                setDisabled={setDisabled}
                onChange={(inputFile, identifier) =>
                    handleChange(inputFile, identifier)
                }
                onDelete={identifier => handleDelete(identifier)}
            />
        );
    });

    if (multiFileInput.uploadedFiles.length < props.maxFiles) {
        const key = multiFileInput.uploadedFiles.length;

        fileItems.push(
            <SingleUploadField
                {...props}
                key={key}
                identifier={key}
                value={""}
                disabled={disabled}
                setDisabled={setDisabled}
                onChange={(inputFile, identifier) =>
                    handleChange(inputFile, identifier)
                }
            />
        );
    }

    return <MultiFileWrapper>{fileItems}</MultiFileWrapper>;
};

export default MultiUploadField;